import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { RootState } from "store";
import UserRole from "enums/UserRole";
import { BackButton, TermsTemplate } from "@mwi/ui";
import useUpdateEffect from "hooks/useUpdateEffect";

const TermsPage = (): JSX.Element => {
  const navigate = useNavigate();

  const { user, practice, isAuthenticated } = useSelector(
    (state: RootState) => ({
      user: state.auth.user,
      practice: state?.practice,
      isAuthenticated: state.auth.authenticated,
    }),
  );

  const handleBack = () => {
    window.history.length > 0 ? navigate(-1) : navigate("/");
  };

  /* 
    Skip initial render, and then check condition after
    update render as Redux selector is null on initial render.
  */
  useUpdateEffect(() => {
    if (!isAuthenticated || user?.role === UserRole.MWI_ADMIN) {
      navigate("/");
    }
  }, [isAuthenticated, user?.role]);

  return (
    <>
      <BackButton className="mb-14" onClick={handleBack} />

      <h1 className="mb-8">Terms & Conditions Policy</h1>

      <TermsTemplate
        email={practice?.email ?? null}
        phone={practice?.phone ?? null}
        address={practice?.address ?? null}
        displayName={practice?.displayName ?? null}
        privacyLink={practice?.privacyLink ?? null}
      />
    </>
  );
};

export default TermsPage;
